export function clickOutsideUtils() {
  document.querySelector('body')?.click();
}
